// extracted by mini-css-extract-plugin
export default {"comment":"index_comment_kWAyM","image":"index_image_Ij0aJ"};